// extracted by mini-css-extract-plugin
export default {"emptyOutline":"EmptyOutline_emptyOutline__j2VZ7"};